import { ChangeDetectorRef, Component } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import {
  PaginatedResponse,
  RecursiveInterface,
} from '@app/services/base-authenticated.service';
import {
  DocumentTypeOptions,
  PreventiveInterface,
} from '@app/interface/preventive';
import { MatTableDataSource } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { CompanyApi } from '@app/services/company-api';
import { CompanyInterface } from '@app/interface/company';
import { Observable } from 'rxjs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
// import {AsyncPipe} from '@angular/common';
import { map, startWith } from 'rxjs/operators';
// import { OnInit } from '@angular/core';
import { CompanyAutocompleteComponent } from '@app/company-autocomplete/company-autocomplete';
// import { LayoutComponent } from '@app/layout/layout.component';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSort, Sort, MatSortModule } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { AfterViewInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import {
  MatExpansionModule,
  MatExpansionPanel,
} from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ConfirmInvoiceDialogComponent } from '@app/confirm-invoice-dialog/confirm-invoice-dialog.component';
import { ConfirmInvoiceDeleteComponent } from '@app/confirm-delete-dialog/confirm-delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingDialogComponent } from '@app/loading-dialog/loading-dialog.component';
import { PreventiveApiService } from '@app/services/preventive-api.service';
import { SelectPdfStyleDialogComponent } from '@app/select-pdf-style-dialog/select-pdf-style-dialog.component';
import { BackHeaderComponent } from '@app/back-header/back-header.component';
import { MatSelectChange } from '@angular/material/select';
import { ConfirmEmailSendDialogComponent } from '@app/confirm-email-send-dialog/confirm-email-send-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProductserviceApiService } from '@app/services/productservice-api.service';
import { ProductServiceInterface } from '@app/interface/product-service';

@Component({
  selector: 'izy-preventives-table',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSelectModule,
    MatAutocompleteModule,
    // AsyncPipe,
    // CompanyAutocompleteComponent,
    // LayoutComponent,
    MatPaginatorModule,
    MatPaginator,
    MatCardModule,
    MatCheckboxModule,
    MatSortModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatChipOption,
    MatChipsModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionPanel,
    MatTooltipModule,
    BackHeaderComponent,
    MatProgressSpinnerModule,
  ],
  providers: [PreventiveApiService, MatSnackBar, CompanyApi],
  standalone: true,
  templateUrl: './preventives-table.component.html',
  styleUrl: './preventives-table.component.scss',
})
export class PreventivesTableComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatExpansionPanel) expansionPanel!: MatExpansionPanel;

  private _liveAnnouncer = inject(LiveAnnouncer);

  isLoading = true;

  totalpreventives: number = 0;
  paidpreventives: number = 0;

  filterPanelOpenState = false;
  advancedFilters = false; // Toggle for advanced filters

  // year filter
  currentYear = new Date().getFullYear();
  years: number[] = [];
  selectedYear: number = this.currentYear;

  getActiveFilterCount(): number {
    return Object.values(this.filters).filter(
      (val) => val !== null && val !== '',
    ).length;
  }

  displayedColumns: string[] = [
    'Actions', // Actions
    'document_type',
    // 'invoice_name',
    'amount',
    // 'currency',
    // 'organization_id',
    'preventives_progressive_number',
    'company',
    'description',
    'emission_date',
    // 'is_paid',
  ];
  dataSource = new MatTableDataSource<PreventiveInterface>([]); // now usng MatTableDataSource
  companySource = new MatTableDataSource<CompanyInterface>([]); // now usng MatTableDataSource

  myControl = new FormControl('');
  companyNames: string[] = []; // Array to store company names
  filteredOptions!: Observable<string[]>;

  showDelay = new FormControl(700);
  hideDelay = new FormControl(1000);

  // filter for the table
  filters: any = {
    amount_gt: null,
    amount_lt: null,
    emission_date_after: null, // New min emission date
    emission_date_before: null, // New max emission date
    payment_date_after: null, // New min payment date
    payment_date_before: null, // New max payment date
    status: null,
    company_name_icontains: null,
  };

  filterOptions = [
    { name: 'Tutti', value: 'all' },
    // { name: 'Paid', value: 'paid' },
    // { name: 'Unpaid', value: 'unpaid' },
  ];
  selectedFilter = 'all';
  filteredpreventives: PreventiveInterface[] = []; // For mobile cards

  documentTypeOptions: DocumentTypeOptions[] = [
    { code: 'TD01', name: 'Fattura' },
    { code: 'TD04', name: 'Nota di credito' },
  ];

  newPreventive: Partial<PreventiveInterface> = {
    invoice_name: '',
    amount: 0,
    organization_id: 1,
    // company: {company_name:'default', id:1},
    company_id: 1,
    currency: 'EUR',
  };

  newCompany: Partial<CompanyInterface> = {
    id: 1,
    company_name: '',
    organization_id: 1,
    company_id: 1,

    iva_number: '',
    ateco_code: '',
  };
  filterValue: string = 'all';

  constructor(
    private snackBar: MatSnackBar,
    // private preventiveService: preventiveApi,
    private preventiveService: PreventiveApiService,
    private companyService: CompanyApi,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private productServiceApi: ProductserviceApiService,
  ) {}

  ngOnInit() {
    this.loadpreventives();
    this.loadCompanies();

    this.generateYears();

    // Initialize filteredOptions after companies are loaded
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => this._filter(value || '')),
    );

    this.isLoading = false;
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  generateYears(): void {
    const currentYear = new Date().getFullYear();
    const startYear = 2024; // You can change this start year
    const endYear = currentYear + 2; // You can change this end year

    for (let year = startYear; year <= endYear; year++) {
      this.years.push(year);
    }

    // Optionally set default selection
    this.selectedYear = currentYear;
  }

  onYearSelected(event: MatSelectChange): void {
    this.loadpreventives();
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  // private loadpreventives() {
  //   this.preventiveService.getpreventiveList({}).subscribe({
  //     next: (response: PaginatedResponse<PreventiveInterface>) => {
  //       this.dataSource.data = response.results;
  //       this.dataSource.paginator = this.paginator;

  //       // Calculate statistics
  //       this.totalpreventives = response.results.length;
  //       this.paidpreventives = response.results.filter(
  //         (preventive) => preventive.is_paid
  //       ).length;

  //       console.log('loaded');
  //     },
  //     error: (err: any) => {
  //       console.error('Error loading preventives:', err);
  //       this.showErrorMessage('Failed to load preventives');
  //     },
  //   });
  // }

  getDocumentTypeName(code: string): string {
    const found = this.documentTypeOptions.find(
      (option) => option.code === code,
    );
    return found ? found.name : 'Documento';
  }

  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // Formats as YYYY-MM-DD
  }

  // Riepilogo mostrato in tooltip al passaggio del mouse sulla riga.
  // Il numero di righe prodotto/servizio non arriva con la lista preventivi
  // (che contiene solo l'intestazione), quindi viene caricato al primo hover
  // e messo in cache per preventivo.
  private productServiceCounts = new Map<number, number>();
  private loadingProductServiceCounts = new Set<number>();

  onRowHover(preventive: PreventiveInterface): void {
    if (
      !preventive?.id ||
      this.productServiceCounts.has(preventive.id) ||
      this.loadingProductServiceCounts.has(preventive.id)
    ) {
      return;
    }

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.loadingProductServiceCounts.add(preventive.id);

    this.productServiceApi
      .getAllProductsServices<ProductServiceInterface>(
        preventive.id,
        organization_id,
      )
      .subscribe({
        next: (response: RecursiveInterface<ProductServiceInterface>) => {
          if (!response.completed) {
            return;
          }
          this.productServiceCounts.set(preventive.id, response.results.length);
          this.loadingProductServiceCounts.delete(preventive.id);
          this.cdr.markForCheck();
        },
        error: (err: any) => {
          console.error('Error loading product services count:', err);
          this.loadingProductServiceCounts.delete(preventive.id);
        },
      });
  }

  getRowTooltip(preventive: PreventiveInterface): string {
    const progressiveNumber =
      preventive.preventives_progressive_number ||
      preventive.progressive_number;
    const enumeration =
      preventive.preventives_enumeration || preventive.enumeration;

    const documentLine = [
      'Preventivo',
      progressiveNumber ? `N. ${progressiveNumber}` : null,
      enumeration ? `(${enumeration})` : null,
    ]
      .filter(Boolean)
      .join(' ');

    const count = this.productServiceCounts.get(preventive.id);

    return [
      documentLine,
      `Descrizione: ${preventive.description?.trim() || '—'}`,
      `Prodotti/servizi: ${count === undefined ? 'caricamento…' : count}`,
      `Totale: ${this.formatTooltipAmount(
        preventive.amount,
        preventive.currency,
      )}`,
      `Note: ${preventive.notes?.trim() || '—'}`,
    ].join('\n');
  }

  private formatTooltipAmount(
    amount: number,
    currency: string = 'EUR',
  ): string {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);
  }

  public loadpreventives() {
    // console.log(this.selectedYear);
    this.isLoading = true;

    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // Prepare filter params
    const filterParams: any = {};

    // Add amount filters
    if (this.filters.amount_gt)
      filterParams.amount__gt = this.filters.amount_gt;
    if (this.filters.amount_lt)
      filterParams.amount__lt = this.filters.amount_lt;

    // date filters
    if (this.filters.emission_date_after)
      filterParams.emission_date__gte = this.formatDate(
        this.filters.emission_date_after,
      );
    if (this.filters.emission_date_before)
      filterParams.emission_date__lte = this.formatDate(
        this.filters.emission_date_before,
      );

    if (this.filters.payment_date_after)
      filterParams.payment_date__gte = this.formatDate(
        this.filters.payment_date_after,
      );
    if (this.filters.payment_date_before)
      filterParams.payment_date__lte = this.formatDate(
        this.filters.payment_date_before,
      );

    // Add status filter
    if (this.filters.status) filterParams.status = this.filters.status;

    // Add company name filter
    if (this.filters.company_name_icontains)
      filterParams.company__company_name__icontains =
        this.filters.company_name_icontains;

    setTimeout(() => {
      this.filterPanelOpenState = false;
      // or: this.expansionPanel.close();
    }, 100);

    filterParams.is_draft = false; // ensures only non-drafts are fetched
    filterParams.is_deleted = false; // hide deleted preventives
    filterParams.is_preventive = true; // only preventives
    filterParams.is_saved_for_preview = false;
    filterParams.emission_date__year = this.selectedYear;

    // Using getRecursivePage to load all preventives across all pages
    this.preventiveService
      .getAllPreventives<PreventiveInterface>(organization_id, filterParams)
      .subscribe({
        next: (response: RecursiveInterface<PreventiveInterface>) => {
          if (response.completed) {
            // All data has been loaded
            this.dataSource.data = response.results;
            this.dataSource.paginator = this.paginator;

            // Apply current filter
            this.applyFilter(this.selectedFilter);
            this.filteredpreventives = [...response.results]; // Initialize mobile view data

            // Calculate statistics
            this.totalpreventives = response.count; // Use count from response
            // this.paidpreventives = response.results.filter(
            //   (preventive) => preventive.is_paid
            // ).length;

            console.log('All preventives loaded', response.results.length);
          } else {
            // Optional: Show loading progress if you want
            console.log(`Loaded ${response.results.length} drafts so far...`);
          }
          this.isLoading = false;
        },
        error: (err: any) => {
          console.error('Error loading drafts:', err);
          this.showErrorMessage('Errore durante il caricamento.');
          this.isLoading = false;
        },
      });
  }

  // function to load companies from interface
  private loadCompanies() {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // this.isLoading = true;

    // Prepare filter params
    const filterParams: any = {};
    filterParams.is_deleted = false; // hide deleted invoices

    this.companyService
      .getAllCompanies<CompanyInterface>(organization_id, filterParams)
      .subscribe({
        next: (companies: RecursiveInterface<CompanyInterface>) => {
          this.companySource.data = companies.results;
          // Extract company names from the response
          this.companyNames = companies.results.map(
            (company) => company.company_name,
          );
          console.log('loaded companies');
        },
        error: (err: any) => {
          console.error('Error loading companies:', err);
          this.showErrorMessage('Errore durante il caricamento clienti.');
        },
      });
  }

  resetFilters() {
    this.filters = {
      amount_gt: null,
      amount_lt: null,
      emission_date_after: null,
      emission_date_before: null,
      payment_date_after: null,
      payment_date_before: null,
      status: null,
      company_name_icontains: null,
    };
    this.loadpreventives();
  }

  addNewElement(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(
      !this.newPreventive.organization_id || !this.newPreventive.company?.id,
    );
    console.log(this.newPreventive);
    this.preventiveService
      .createPreventive(organization_id, this.newPreventive)
      .subscribe({
        next: (createdPreventive: PreventiveInterface) => {
          this.dataSource.data = [...this.dataSource.data, createdPreventive];
          this.showSuccessMessage(
            `${createdPreventive.invoice_name} (amount ${createdPreventive.amount}) added successfully!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating preventive:', err);
          this.showErrorMessage('Errore durante la creazione preventivo.');
        },
      });
  }

  addNewCompany(form?: NgForm) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    // validate required fields
    console.log(!this.newCompany.organization_id || !this.newCompany.id);
    console.log(this.newCompany);
    this.companyService
      .createCompany(organization_id, this.newCompany)
      .subscribe({
        next: (createdCompany: CompanyInterface) => {
          this.companySource.data = [
            ...this.companySource.data,
            createdCompany,
          ];
          this.showSuccessMessage(
            `${createdCompany.company_name} (ID ${createdCompany.id}) aggiunto con successo!`,
          );
          this.resetForm(form);
        },
        error: (err: any) => {
          console.error('Error creating company:', err);
          this.showErrorMessage('Errore durante il la creazione.');
        },
      });
  }

  // used in the autocomplete?
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.companyNames.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  onCompanyNameSelected(companyName: string) {
    const selectedCompany = this.companySource.data.find(
      // companySource?
      (company: { company_name: string }) =>
        company.company_name === companyName,
    );

    if (selectedCompany) {
      this.newPreventive.company_id = selectedCompany.id;
      console.log('Selected company ID:', selectedCompany.id);
    }
  }

  navigateTonewPreventive() {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    console.log(org_id);
    this.router.navigate([`/${org_id}/new_preventive`]);
  }

  onRowClick(preventive: PreventiveInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/preventive`, preventive.id]);
  }

  togglePaidStatus(preventive: PreventiveInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.preventiveService
      .updatePreventiveDetails(organization_id, preventive.id, {
        is_paid: preventive.is_paid,
      })
      .subscribe({
        next: (updatedpreventive: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === preventive.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedpreventive;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalpreventives = this.dataSource.data.length;
            this.paidpreventives = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `preventive ${preventive.invoice_name} updated successfully!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating preventive:', err);
          // Revert the checkbox if the update fails
          preventive.is_paid = !preventive.is_paid;
          // this.showErrorMessage('Failed to update preventive status');
        },
      });
  }

  toggleDraftStatus(preventive: PreventiveInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.preventiveService
      .updatePreventiveDetails(organization_id, preventive.id, {
        is_draft: false,
      })
      .subscribe({
        next: (updatedpreventive: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === preventive.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedpreventive;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalpreventives = this.dataSource.data.length;
            this.paidpreventives = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `preventive ${preventive.invoice_name} sent successfully to the server!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating preventive:', err);
          // Revert the checkbox if the update fails
          preventive.is_draft = !preventive.is_draft;
          this.showErrorMessage('Failed to send preventive.');
        },
      });
  }

  // to publish the saved draft (after opening the dialog)
  // async publishDraft(preventive: PreventiveInterface, form?: NgForm) {
  //   // akss the user for confirmation
  //   const dialogRef = this.dialog.open(ConfirmInvoiceDialogComponent);
  //   const result = await dialogRef.afterClosed().toPromise();

  //   if (!result) {
  //     // User cancelled the dialog
  //     return;
  //   }

  //   // TODO: actually publish to Aruba

  //   this.toggleDraftStatus(preventive);
  // }

  toggleIsDeletedStatus(preventive: PreventiveInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    this.preventiveService
      .updatePreventiveDetails(organization_id, preventive.id, {
        is_deleted: true,
      })
      .subscribe({
        next: (updatedpreventive: any) => {
          // Update the local data
          const index = this.dataSource.data.findIndex(
            (i) => i.id === preventive.id,
          );
          if (index !== -1) {
            this.dataSource.data[index] = updatedpreventive;
            this.dataSource.data = [...this.dataSource.data]; // Trigger update

            // Update statistics
            this.totalpreventives = this.dataSource.data.length;
            this.paidpreventives = this.dataSource.data.filter(
              (i) => i.is_paid,
            ).length;
          }

          this.showSuccessMessage(
            `preventive ${preventive.invoice_name} successfully deleted!`,
          );
        },
        error: (err: any) => {
          console.error('Error updating preventive:', err);
          // Revert the checkbox if the update fails
          preventive.is_deleted = !preventive.is_deleted;
          this.showErrorMessage("Errore durante l'operazione. Riprovare.");
        },
      });
  }

  // deletepreventive(preventive: PreventiveInterface) {
  //   this.preventiveService.softDeletepreventive(preventive.id).subscribe({
  //     next: (deletedpreventive) => {
  //       // Remove the preventive from the data source
  //       this.dataSource.data = this.dataSource.data.filter(
  //         (i) => i.id !== preventive.id
  //       );
  //       this.dataSource.data = [...this.dataSource.data]; // Trigger update

  //       // Update statistics
  //       this.totalpreventives = this.dataSource.data.length;
  //       this.paidpreventives = this.dataSource.data.filter(
  //         (i) => i.is_paid
  //       ).length;

  //       this.showSuccessMessage(
  //         `preventive "${preventive.invoice_name}" deleted successfully!`
  //       );
  //     },
  //     error: (err) => {
  //       console.error('Error deleting preventive:', err);
  //       this.showErrorMessage('Failed to delete preventive');
  //     },
  //   });
  // }

  // soft delete
  async deletepreventive(preventive: PreventiveInterface) {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmInvoiceDeleteComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '250px',
      maxHeight: '90vh',
      data: {
        preventiveName: preventive.invoice_name,
        message: 'Sicuro di voler eliminare la fattura?', // Custom message
        checkboxLabel: 'Confermo di voler eliminare la fattura e accetto', // Custom checkbox label
      },
    });

    const result = await dialogRef.afterClosed().toPromise();

    if (result) {
      // User confirmed deletion - show loading dialog
      const loadingDialogRef = this.dialog.open(LoadingDialogComponent, {
        width: '90vw',
        maxWidth: '400px',
        height: '300px',
        disableClose: true, // Prevent closing during loading
      });

      // Simulate 2-second delay + actual API call
      try {
        // Combine fake delay with actual API call
        await Promise.all([
          new Promise((resolve) => setTimeout(resolve, 2000)), // 2-second delay
          this.preventiveService
            .updatePreventiveDetails(organization_id, preventive.id, {
              is_deleted: true,
            })
            .toPromise(),
        ]);

        // Close loading dialog
        loadingDialogRef.close();

        // Remove from local data
        this.dataSource.data = this.dataSource.data.filter(
          (i) => i.id !== preventive.id,
        );
        this.filteredpreventives = this.filteredpreventives.filter(
          (i) => i.id !== preventive.id,
        );

        // Update statistics
        this.totalpreventives = this.dataSource.data.length;
        this.paidpreventives = this.dataSource.data.filter(
          (i) => i.is_paid,
        ).length;

        this.showSuccessMessage(
          `Fattura ${preventive.invoice_name} eliminata con successo!`,
        );
      } catch (err: any) {
        // Close loading dialog on error
        loadingDialogRef.close();

        console.error('Error deleting preventive:', err);
        this.showErrorMessage('Impossibile eliminare la fattura');
      }
    }
  }

  openCustomerPage(invoice: PreventiveInterface) {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/company`, invoice.company.id]);
  }

  applyFilter(filterValue: string) {
    this.selectedFilter = filterValue;

    // Filter logic for both table and cards
    if (filterValue === 'all') {
      this.dataSource.filter = '';
      this.filteredpreventives = this.dataSource.data;
    } else {
      this.dataSource.filterPredicate = (
        data: PreventiveInterface,
        filter: string,
      ) => {
        if (filter === 'paid') return data.is_paid;
        if (filter === 'unpaid') return !data.is_paid;
        return true;
      };
      this.dataSource.filter = filterValue;
      this.filteredpreventives = this.dataSource.data.filter((preventive) => {
        if (filterValue === 'paid') return preventive.is_paid;
        if (filterValue === 'unpaid') return !preventive.is_paid;
        return true;
      });
    }

    // Update statistics based on filtered data
    const filteredData =
      this.filterValue === 'all'
        ? this.dataSource.data
        : this.filteredpreventives;
    this.totalpreventives = filteredData.length;
    this.paidpreventives = filteredData.filter(
      (preventive) => preventive.is_paid,
    ).length;
  }

  private resetForm(form?: NgForm) {
    if (form) {
      form.resetForm();
    }
    ((this.newPreventive = {
      invoice_name: '',
      amount: 0,
      organization_id: 1,
      // company: this.companies[0], // {company_name:'default', id:1}
      company_id: 1,
    }),
      console.log('reset'));
  }

  downloadPreventivePdf(invoiceId: number): void {
    // Open the dialog first
    const dialogRef = this.dialog.open(SelectPdfStyleDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '465px',
      data: {
        title: 'Scarica PDF Preventivo',
        message: 'Seleziona lo stile del PDF che preferisci.',
      },
    });

    // Handle dialog result
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.download) {
        try {
          // Pass the selected style to your service
          this.preventiveService.downloadPreventivePdf(invoiceId, result.style);
          this.showSuccessMessage(
            `Il preventivo è stato scaricato sul dispositivo!`,
          );
        } catch (error) {
          this.showErrorMessage('Errore nel download PDF');
        }
      }
    });
  }

  async sendInvoiceEmail(
    preventiveId: number,
    Preventive: PreventiveInterface,
  ): Promise<void> {
    const organization_id = Number(
      this.route.snapshot.paramMap.get('organizationId'),
    );

    const dialogRef = this.dialog.open(ConfirmEmailSendDialogComponent, {
      width: '90vw',
      maxWidth: '400px',
      height: '400px',
      data: {
        email_address: Preventive.company.email_address,
        company_id: Preventive.company.id,
        organization_id: organization_id,
      },
    });
    const result = await dialogRef.afterClosed().toPromise();

    if (!result) {
      // User cancelled the dialog
      return;
    }

    try {
      this.preventiveService.sendEmailWithPDF(organization_id, preventiveId);
      this.showSuccessMessage(
        `Il preventivo è stato inviato al cliente con successo!`,
      );
    } catch (error) {
      this.showErrorMessage('Errore invio email con PDF.');
    }
  }

  backToDashboard(): void {
    const org_id = this.route.snapshot.paramMap.get('organizationId');
    this.router.navigate([`/${org_id}/dashboard`]);
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  private showErrorMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['error-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
